import React from 'react'

interface ElIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export const ElIcon = (props: ElIconProps) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <g clipPath="url(#clip0_12114_94790)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 1.19922H21V3.42578H1V1.19922Z"
          fill="#005BAE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 3.42578H21V5.65234H1V3.42578Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 5.65234H21V7.87891H1V5.65234Z"
          fill="#005BAE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 7.87891H21V10.1055H1V7.87891Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 10.1055H21V12.3281H1V10.1055Z"
          fill="#005BAE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 12.3281H21V14.5547H1V12.3281Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 14.5547H21V16.7812H1V14.5547Z"
          fill="#005BAE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 16.7812H21V19.0078H1V16.7812Z"
          fill="white"
        />
        <path d="M1 1.19922H12.1289V12.3281H1V1.19922Z" fill="#005BAE" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.45312 1.19922H7.67891V12.3281H5.45312V1.19922Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 5.65039H12.1289V7.87617H1V5.65039Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 18.9727H21V21.1992H1V18.9727Z"
          fill="#005BAE"
        />
      </g>
      <path
        d="M11 0.699219C16.799 0.699219 21.5 5.40023 21.5 11.1992C21.5 16.9982 16.799 21.6992 11 21.6992C5.20101 21.6992 0.5 16.9982 0.5 11.1992C0.5 5.40023 5.20101 0.699219 11 0.699219Z"
        stroke="#D6D8DC"
      />
      <defs>
        <clipPath id="clip0_12114_94790">
          <path
            d="M1 11.1992C1 5.67637 5.47715 1.19922 11 1.19922C16.5228 1.19922 21 5.67637 21 11.1992C21 16.7221 16.5228 21.1992 11 21.1992C5.47715 21.1992 1 16.7221 1 11.1992Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
